import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-entity-list-info-modal',
  templateUrl: './entity-list-info-modal.component.html',
  styleUrls: ['./entity-list-info-modal.component.scss']
})
export class EntityListInfoModalComponent {
  dialogRef = inject(MatDialogRef<EntityListInfoModalComponent>);
  close() {
    this.dialogRef.close(null);
  }
}
